import React from 'react'
import { Breadcrumb } from 'react-bootstrap'

const Breadcrumbs = props => {
	return <Breadcrumb bsPrefix="breadcrumb bg-transparent pl-0 mb-0">{props.children}</Breadcrumb>
}

export default Breadcrumbs
